import { render } from "./FormInput.vue?vue&type=template&id=6f0c5d26&scoped=true"
import script from "./FormInput.vue?vue&type=script&lang=js"
export * from "./FormInput.vue?vue&type=script&lang=js"

import "./FormInput.vue?vue&type=style&index=0&id=6f0c5d26&scoped=true&lang=css"

import exportComponent from "/var/www/abg/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0c5d26"]])

export default __exports__